import { createLucideIcon } from "lucide-react";

// SVG adaptations of the designer references supplied on 2026-09-28.
// These are redrawn from screenshots, not the original vector assets.
// Use the same 24px grid and currentColor stroke as the surrounding tools.
export const DimensionIcon = createLucideIcon("ArchitectDimension", [
  ["path", { d: "M3 6v12M21 6v12M7 9v6M17 9v6M3 12h18", key: "dimension" }],
]);

export const AngleIcon = createLucideIcon("ArchitectAngle", [
  ["path", { d: "M5 19V5h14", key: "rays" }],
  ["path", { d: "M5 15A10 10 0 0 0 15 5", strokeDasharray: "2 4", key: "arc" }],
]);

export const HatchedAreaIcon = createLucideIcon("ArchitectHatchedArea", [
  ["path", { d: "M5 5h14v14H5z", key: "boundary" }],
  ["path", { d: "m5 11 6-6M5 17 17 5M9 19 19 9m-4 10 4-4", key: "hatch" }],
]);

export const RevisionCloudIcon = createLucideIcon("ArchitectRevisionCloud", [
  ["path", { d: "M8 20a7 7 0 1 1 6.9-8.2A4.2 4.2 0 1 1 17.5 20Z", key: "cloud" }],
]);
